export enum DrawerState {
  Bottom,
  Docked,
  Top
}
